import angular from 'angular';
import newLoanStructure from './newLoanStructure';

export default angular
  .module('components.newLoanStructure', [])
  .component('newLoanStructure', newLoanStructure).name;
